import { create } from 'zustand';

// ── A BODY OF YOUR OWN: THE MANNEQUINS (2026-11-01) ──────────────────────────
//
// Khari: "We should bring back the 3rd person view. This means giving users a
// body again … bringing back the character/avatar selection screen, but
// replacing the artists there with generic manneuquins the user can choose
// from." Then, the same day: "I have found a model that has a set of characters
// in it … This will give the user a selection of models to choose from."
//
// A visitor's body is never an artist's (2026-10-23: the artists live their own
// lives); it is one of these, chosen on the selection screen and remembered on
// this device. OUR OWN (2026-11-01, Khari: "It may be better to just make our
// own new characters from a plate. these premade characters come with issues"):
// six dressed mannequins in plain outfits, built the way every body is built —
// four plates (API scripts/make_mannequin_set.js, a wide-A pose so the rigger
// never welds a hand to a hip), turned silver-grey with GPT Image 2 ("so the
// mannequins are silver/grey"), meshed with tripo3d, rigged on the standard
// 24-joint rig with walk + idle, finished by scripts/finish_mannequin.mjs.
// Sources: World DOCS/WORLD/models/mannequins_v2/. (The downloaded set it
// replaces is kept in DOCS/WORLD/models/mannequins/, unused.)
//
// ⚠ Served from the World host, VERSIONED: GLBs there are cached `immutable`
// for a year, so a rebuilt mannequin must bump `V`.
// `height` is world units at the world's 1u ≈ 2.2m (a 1.88m man → 0.855, a
// 1.82m woman → 0.83 — Khari, beside Abra at 0.90: "size difference").
// `thumb` is the figure cut from its own silver front plate.
// 20261101e: packed for the web (scripts/web_pack_glb.mjs, ~4.5 → ~1.35 MB).
const V = '20261101e';
const F = '/silhouettes/female.png';
const M = '/silhouettes/male.png';
const fig = (key, label, group, height) => ({
  key, label, group, height,
  url: `/models/mannequins/${key}.glb?v=${V}`,
  thumb: `/models/mannequins/thumbs/${key}.jpg?v=${V}`,
  silhouette: group === 'Female' ? F : M,   // the stand-in while the body loads
});
export const MANNEQUINS = {
  f1: fig('f1', 'Black tee', 'Female', 0.83),
  f2: fig('f2', 'Cream sweater', 'Female', 0.83),
  f3: fig('f3', 'Burgundy track', 'Female', 0.83),
  m1: fig('m1', 'White tee', 'Male', 0.855),
  m2: fig('m2', 'Charcoal hoodie', 'Male', 0.855),
  m3: fig('m3', 'Olive bomber', 'Male', 0.855),
};
export const MANNEQUIN_KEYS = Object.keys(MANNEQUINS);

// ── EDITABLE IN THE MODEL LAB (2026-11-01, API migration 464) ───────────────
// Khari: "a way to edit/adjust them in the model lab/editor". The bodies live in
// the API's `world_mannequins` (owned by user 1, edited in the Lab's Mannequins
// mode); the list above is the BUNDLED FALLBACK the World uses until that table
// exists or when the API cannot be reached. Loaded once at boot and swapped in
// place — MANNEQUINS and MANNEQUIN_KEYS keep their identity, so every reader sees
// the new set; `useMannequinList` re-renders the picker. `pose` is the body's
// saved look and rig corrections (gloss, shoulderDrop, elbowIn…), the same shape
// an artist body's pose has, handed to AnimatedResident as rigPose.
export const useMannequinList = create(() => ({ v: 0, source: 'bundled' }));
export async function loadMannequins(fetchList) {
  try {
    const { ready, list } = await fetchList();
    if (!ready || !list.length) return;
    for (const k of Object.keys(MANNEQUINS)) delete MANNEQUINS[k];
    for (const m of list) {
      MANNEQUINS[m.key] = {
        key: m.key, label: m.label, group: m.group, height: Number(m.height) || 0.84,
        url: m.url, thumb: m.thumb || null, pose: m.pose || null,
        silhouette: m.group === 'Female' ? F : M,
      };
    }
    MANNEQUIN_KEYS.splice(0, MANNEQUIN_KEYS.length, ...list.map((m) => m.key));
    // A choice that is no longer offered falls back to the nearest the set has.
    const st = useBodyStore.getState(); if (st.body && !MANNEQUINS[st.body]) st.setBody(resolveBody(st.body) || null);
    useMannequinList.setState((s) => ({ v: s.v + 1, source: 'api' }));
    console.info(`[mannequins] ${list.length} from the API (world_mannequins)`);
  } catch (e) {
    console.warn('[mannequins] kept the bundled set:', e?.message || e);
  }
}

// The first pair (the procedural figures, earlier the same day) answered to
// 'm' / 'f'. A choice saved then — or a visitor still on that build, whose key
// arrives through the socket — lands on the nearest of this set.
const LEGACY = { m: 'm1', f: 'f1' };
export const resolveBody = (k) => (MANNEQUINS[k] ? k : (MANNEQUINS[LEGACY[k]] ? LEGACY[k] : null));

const KEY = 'world:body';
const read = () => { try { return resolveBody(localStorage.getItem(KEY)); } catch { return null; } };

/** The body this visitor chose (a MANNEQUINS key), or null before they have chosen. */
export const useBodyStore = create((set) => ({
  body: read(),
  setBody: (body) => {
    const v = resolveBody(body);
    try { if (v) localStorage.setItem(KEY, v); else localStorage.removeItem(KEY); } catch { /* private mode */ }
    set({ body: v });
  },
}));

/** The chosen mannequin as a body PlayerBody can draw, or null. */
export function mannequinRig(key) {
  const m = MANNEQUINS[resolveBody(key)];
  // `presents`: the figure's own group (Female / Male), for the moves picked for it (a seated idle: city/bodyLanguage).
  return m ? { key: m.key, rigged: m.url, walk: null, idle: null, height: m.height, pose: m.pose || null, presents: m.group === 'Female' ? 'f' : m.group === 'Male' ? 'm' : null } : null;
}
